module.exports = __webpack_public_path__ + "img/CY.5935b00f.png";